import React from 'react';
import { AlertTriangle, Wifi, WifiOff } from 'lucide-react';

interface DegradationBannerProps {
  level: number;
  message: string;
  onDismiss?: () => void;
}

export const DegradationBanner: React.FC<DegradationBannerProps> = ({
  level,
  message,
  onDismiss,
}) => {
  const getIcon = () => {
    switch (level) {
      case 1:
        return <Wifi size={16} className="text-yellow-500" />;
      case 2:
        return <WifiOff size={16} className="text-red-500" />;
      default:
        return <AlertTriangle size={16} className="text-yellow-500" />;
    }
  };
  
  const getBgColor = () => {
    switch (level) {
      case 1:
        return 'bg-yellow-500/10 border-yellow-500/30';
      case 2:
        return 'bg-red-500/10 border-red-500/30';
      default:
        return 'bg-yellow-500/10 border-yellow-500/30';
    }
  };
  
  const getTextColor = () => {
    switch (level) {
      case 1:
        return 'text-yellow-400';
      case 2:
        return 'text-red-400';
      default:
        return 'text-yellow-400';
    }
  };
  
  return (
    <div
      className={`flex items-center gap-2 px-4 py-2 rounded-lg border ${getBgColor()} ${getTextColor()}`}
    >
      {getIcon()}
      <span className="flex-1 text-sm">{message}</span>
      {onDismiss && (
        <button
          onClick={onDismiss}
          className="text-current opacity-60 hover:opacity-100"
        >
          ✕
        </button>
      )}
    </div>
  );
};

export default DegradationBanner;
